import React from 'react';
import {NoDataMsg} from '@albert-io/atomic';

import {AddClassButton} from '../../NewClassroomModal/NewClassroomModal.react';

const ActiveClassesEmptyState = () => (
  <NoDataMsg.Container className='teacher-classes__empty-state u-mar-t_6'>
    <NoDataMsg.Heading as='h1'>You have no classes</NoDataMsg.Heading>
    <NoDataMsg.Body className='u-mar-b_5'>
      Creating a class is the first step to providing students with the practice they need. You can
      create a class for each period or section you teach.
    </NoDataMsg.Body>
    <AddClassButton />
  </NoDataMsg.Container>
);

export default ActiveClassesEmptyState;
